document.addEventListener('DOMContentLoaded', function() {
  // 初始化所有 mt-feature-panels 组件
  document.querySelectorAll('.mt-feature-panels').forEach(function(section) {
    const left = section.querySelector('[data-left]');
    const scroller = section.querySelector('[data-scroller]');
    const items = section.querySelector('[data-items]');
    const prevBtn = section.querySelector('[data-prev]');
    const nextBtn = section.querySelector('[data-next]');
    const progressBar = section.querySelector('[data-bar]');
    const controls = section.querySelector('[data-controls]');
    const progress = section.querySelector('[data-progress]');
    
    if (!left || !scroller || !items) return;
    
    const hasControls = left.getAttribute('data-has-controls') === 'true';
    
    if (!hasControls) return;
    
    let currentIndex = 0;
    const allItems = items.children;
    const totalItems = allItems.length;
    
    // 如果项目数量少于等于2个，不需要控制器
    if (totalItems <= 2) {
      if (controls) controls.hidden = true;
      if (progress) progress.hidden = true;
      return;
    }
    
    // 获取单个项目的宽度（包括gap）
    function getItemWidth() {
      if (allItems.length === 0) return 0;
      const itemRect = allItems[0].getBoundingClientRect();
      
      // 检测是否为移动端
      const isMobile = window.innerWidth <= 749;
      
      if (isMobile) {
        // 移动端：CSS设置为 calc(100vw - 30px) + 20px gap
        // 所以滑动距离应该是 calc(100vw - 10px)
        const viewportWidth = window.innerWidth;
        return viewportWidth - 10; // 100vw - 10px
      } else {
        // 桌面端：使用原来的gap计算
        const gap = 20;
        return itemRect.width + gap;
      }
    }
    
    // 获取可见区域能显示的项目数量
    function getVisibleItemsCount() {
      const scrollerRect = scroller.getBoundingClientRect();
      const itemWidth = getItemWidth();
      if (itemWidth === 0) return 2; // 默认值
      
      // 检测是否为移动端
      const isMobile = window.innerWidth <= 749;
      
      if (isMobile) {
        // 移动端：每次只显示一个项目
        return 1;
      } else {
        // 桌面端：根据容器宽度计算
        return Math.floor(scrollerRect.width / itemWidth);
      }
    }
    
    // 更新进度条
    function updateProgressBar() {
      if (!progressBar) return;
      
      const visibleCount = getVisibleItemsCount();
      const maxIndex = Math.max(0, totalItems - visibleCount);
      
      if (maxIndex === 0) {
        progressBar.style.width = '100%';
        return;
      }
      
      // 如果是初始状态（currentIndex = 0），使用平均值（100% / 产品数量）
      if (currentIndex === 0) {
        const averageWidth = (100 / totalItems);
        progressBar.style.width = averageWidth + '%';
        return;
      }
      
      const progress = (currentIndex / maxIndex) * 100;
      progressBar.style.width = progress + '%';
    }
    
    // 滑动到指定索引
    function scrollToIndex(index) {
      const itemWidth = getItemWidth();
      const scrollLeft = index * itemWidth;
      
      // 使用 transform 来实现平滑滑动
      items.style.transform = `translateX(-${scrollLeft}px)`;
      
      currentIndex = index;
      updateProgressBar();
      updateButtonStates();
    }
    
    // 更新按钮状态
    function updateButtonStates() {
      if (!prevBtn || !nextBtn) return;
      
      const visibleCount = getVisibleItemsCount();
      const maxIndex = Math.max(0, totalItems - visibleCount);
      
      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = currentIndex >= maxIndex;
      
      // 添加视觉反馈
      prevBtn.style.opacity = currentIndex <= 0 ? '0.5' : '1';
      nextBtn.style.opacity = currentIndex >= maxIndex ? '0.5' : '1';
    }
    
    // 前进按钮点击事件
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        const visibleCount = getVisibleItemsCount();
        const maxIndex = Math.max(0, totalItems - visibleCount);
        
        if (currentIndex < maxIndex) {
          scrollToIndex(currentIndex + 1);
        }
      });
    }
    
    // 后退按钮点击事件
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        if (currentIndex > 0) {
          scrollToIndex(currentIndex - 1);
        }
      });
    }
    
    // 窗口大小改变时重新计算
    function handleResize() {
      // 重置到合适的位置
      const visibleCount = getVisibleItemsCount();
      const maxIndex = Math.max(0, totalItems - visibleCount);
      
      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }
      
      // 延迟执行，等待CSS重新渲染
      setTimeout(() => {
        scrollToIndex(currentIndex);
        }, 100);
      }
    
    // 添加平滑过渡效果
    if (items) {
      items.style.transition = 'transform 0.3s ease-in-out';
    }
    
    // 监听窗口大小变化
    window.addEventListener('resize', handleResize);
    
    // 初始化
    updateButtonStates();
    updateProgressBar();
    
    // 调试信息（可以在生产环境中移除）
    console.log('Feature Panels Debug:', {
      totalItems: totalItems,
      visibleCount: getVisibleItemsCount(),
      itemWidth: getItemWidth(),
      isMobile: window.innerWidth <= 749,
      maxIndex: Math.max(0, totalItems - getVisibleItemsCount())
    });
    
    // 支持触摸滑动（可选）
      let startX = 0;
      let isDragging = false;
      
    if (scroller) {
      scroller.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        isDragging = true;
      }, { passive: true });
      
      scroller.addEventListener('touchmove', function(e) {
        if (!isDragging) return;
        // 不阻止默认行为，让页面可以正常滚动
      }, { passive: true });
      
      scroller.addEventListener('touchend', function(e) {
        if (!isDragging) return;
        
        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;
        const threshold = 50; // 滑动阈值
        
        if (Math.abs(diff) > threshold) {
          if (diff > 0 && nextBtn && !nextBtn.disabled) {
            // 向左滑动，显示下一个
            nextBtn.click();
          } else if (diff < 0 && prevBtn && !prevBtn.disabled) {
            // 向右滑动，显示上一个
            prevBtn.click();
          }
        }
        
        isDragging = false;
      }, { passive: true });
    }
  });
});